<template>
  <div :class="'rc-header ' + navbarClass">
    <div v-if="navbarType === 'initial'" class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col">
          <Logo />
        </div>
        <div
          class="col text-right"
          @click="gtagEventGoToHelp"
          v-if="showHelpBtn"
        >
          <img :src="helpIconPath" alt="" class="help-icon" />
        </div>
      </div>
    </div>
    <div v-else-if="navbarType === 'goBack'" class="container pt-3 pb-0">
      <div class="row align-items-center justify-content-between">
        <div :class="showHelpBtn ? 'col-9' : 'col'">
          <img
            v-if="showBackBtn"
            :src="backButtonSrc"
            @click="$emit('clicked')"
            alt="back"
          />
          <span class="text-title">{{ screenTitle }}</span>
        </div>
        <div
          v-if="showProgressBar"
          class="progress"
          role="progressbar"
          aria-valuenow="0"
          aria-valuemin="0"
          aria-valuemax="100"
          style="height: 3px"
        >
          <div
            class="progress-bar bg-success"
            :style="{ width: `${progresPercentage}%` }"
          ></div>
        </div>
        <div
          class="col-3 text-right"
          @click="gtagEventGoToHelp"
          v-if="showHelpBtn"
        >
          <button type="button" class="btn btn-sm help-btn">
            <img :src="helpIconPath" alt="" />
          </button>
        </div>
      </div>
    </div>
    <div v-else-if="navbarType === 'simple'" class="container my-0 pb-3 pt-3">
      <h1 class="fw-bold text-center" id="screenTitleSimple">
        {{ screenTitle }}
      </h1>
    </div>
    <div
      v-else-if="navbarType === 'staticIcon'"
      class="container my-0 pb-3 pt-4"
    >
      <div class="d-flex align-items-center justify-flex-start">
        <img :src="staticIcon" alt="icon" />
        <h1 class="fw-bold text-center m-0" id="screenTitleSimple">
          {{ screenTitle }}
        </h1>
      </div>
      <hr class="w-100 mt-0" />
    </div>
    <div v-else-if="navbarType === 'custom'" class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col-9">
          <img
            v-if="showBackBtn"
            :src="backButtonSrc"
            @click="$emit('clicked')"
            alt="back"
            id="back-btn"
          />
          <span class="ms-0 fw-bold text-black">{{ screenTitle }}</span>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from "vue";
import Logo from "@/apps/credit-line/components/Logo.vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useI18n } from "vue-i18n";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import { useRouter } from "vue-router";

type NavBarType = "initial" | "goBack" | "simple" | "custom" | "staticIcon";

export default defineComponent({
  name: "Header",
  emits: ["clicked"],
  components: {
    Logo,
  },
  props: {
    navbarType: {
      type: String as PropType<NavBarType>,
      default: "initial",
    },
    screenTitle: {
      default: "",
      type: String,
    },
    backAction: {
      default: "home",
      type: String,
    },
    showBackBtn: {
      default: true,
      type: Boolean,
    },
    showProgressBar: {
      default: false,
      type: Boolean,
    },
    progresPercentage: {
      default: 0,
      type: Number,
    },
    showHelpBtn: {
      type: Boolean,
      default: false,
    },
    staticIcon: {
      default: "",
      type: String,
    },
    applicationId: {
      type: String,
      default: "",
    },
    helpIcon: {
      type: String,
      default: "",
    },
    hideHelpBtnText: {
      type: Boolean,
      default: false,
    },
    helpQueryParam: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const { t } = useI18n();

    const router = useRouter();

    const navbarClass = computed(() => {
      return "navbar-" + props.navbarType;
    });

    const helpIconPath = useAsset("img/credit-line/help-question-mark.svg");
    const backButtonSrc = useAsset("img/credit-line/back-button.png");

    const gtagEventGoToHelp = () => {
      logAnalyticsEvent(AnalyticEvents.CreditLine.HelpButton, "Application");

      router.push({
        name: "CreditLineHelpView",
        params: { applicationId: props.applicationId },
        query: { faq: props.helpQueryParam },
      });
    };

    return {
      t,
      navbarClass,
      helpIconPath,
      backButtonSrc,
      gtagEventGoToHelp,
    };
  },
});
</script>

<style lang="scss" scoped>
.text-title {
  font-family: Inter, serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
}
</style>
